import React from "react";

export function Btn({ children, onClick }) {
  return (
    <>
      <button
        onClick={onClick}
        className="bg-[#5002D0] text-white font-semibold px-4 py-3 rounded-lg"
      >
        {children}
      </button>
    </>
  );
}

//
export function RoundedBtn({ children, onClick }) {
  return (
    <>
      <button
        className="rounded-full text-white py-[16px] bg-[#5002D0] w-[480px] h-[60px] mt-10 text-[16px] font-[]"
        onClick={onClick}
      >
        {children}
      </button>
    </>
  );
}

export function SmallRoundedBtn({ children, onClick }) {
  return (
    <>
      <button
        className="rounded-full text-white py-[16px] bg-[#5002D0] w-[214px] h-[60px] mt-10 text-[16px] font-[]"
        onClick={onClick}
      >
        {children}
      </button>
    </>
  );
}
